import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import BottomBar from "@/components/BottomBar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import TentangPage from "@/pages/TentangPage";
import LokasiPage from "@/pages/LokasiPage";
import KontakPage from "@/pages/KontakPage";
import FaqPage from "@/pages/FaqPage";
import NotFoundPage from "@/pages/NotFoundPage";

const LenisContext = { current: null };

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (LenisContext.current) {
      LenisContext.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function TrailingSlashRedirect() {
  const { pathname } = useLocation();
  if (pathname !== "/" && !pathname.endsWith("/") && !/\.[a-zA-Z0-9]+$/.test(pathname)) {
    return <Navigate to={`${pathname}/`} replace />;
  }
  return null;
}

function LenisProvider({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    LenisContext.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      LenisContext.current = null;
    };
  }, []);
  return children;
}

export function AppInner() {
  return (
    <LenisProvider>
      <ScrollManager />
      <TrailingSlashRedirect />
      <div className="pb-16 md:pb-0 min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/tentang" element={<TentangPage />} />
            <Route path="/lokasi" element={<LokasiPage />} />
            <Route path="/kontak" element={<KontakPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <BottomBar />
      </div>
    </LenisProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
